import { connect } from 'react-redux';
import ChargerDetailsModal from './component';

const mapStateToProps = (state) => ({
  user: state.login.user,
  chargerModalData: state.chargerDetails.currentCharger,
  chargerModalDataIsFetching: state.chargerDetails.isFetching,
});

export default connect(mapStateToProps)(ChargerDetailsModal);
